export const pokemonRandomizerContent = {
  introduction: {
    titleKey: "pokemonRandomizer_whatIsItTitle",
    content: [
      `宝可梦随机生成器是一种特殊工具，旨在为您的宝可梦冒险注入全新的不可预测性和兴奋感。通过打乱各种游戏元素——例如宝可梦相遇、物品位置、角色能力，甚至属性克制关系——宝可梦随机生成器工具每次都能打造出独特的游戏体验。无论您是寻求新挑战的经验丰富的训练师，还是希望以新颖方式探索宝可梦世界的新玩家，我们的随机生成器都能提供无限可能。沉浸在一个万事皆有可能的宝可梦版本中，您的策略技巧将受到全新的考验！`
    ],
  },
  features: {
    titleKey: "pokemonRandomizer_featuresTitle",
    content: [
      `我们的宝可梦随机生成器凭借其全面的功能套件脱颖而出，旨在实现最大的乐趣和自定义性。您可以根据自己的喜好调整随机化的程度，选择要打乱的元素。从特定路线上的野生宝可梦到您获得的初始宝可梦，甚至是您找到的物品——控制权尽在您手。我们优先考虑无缝的用户体验，确保我们的宝可梦随机生成器易于使用、快速，并能满足您对全新宝可梦旅程的渴望。高级选项允许进行微调，使其成为休闲游戏和硬核挑战（如Nuzlocke模式）的完美随机生成器。`
    ],
  },
  whyUse: {
    titleKey: "pokemonRandomizer_whyUseTitle",
    content: [
      `使用宝可梦随机生成器可以重振经典的宝可梦模式，提供令人难以置信的可重玩性。它打破了旧有习惯，迫使您随机应变，使用您可能从未考虑过的宝可梦队伍制定策略。每一次游戏都会成为一个独特的故事，充满了意想不到的遭遇和挑战。对于内容创作者来说，这是生成引人入胜的宝可梦内容的绝佳方式；对于任何粉丝来说，这也是通过全新视角重新发现他们最喜欢地区的好机会。如果您正在寻求标准宝可梦游戏玩法之外的体验，随机生成器将是您通往无数小时新奇娱乐的大门。`
    ],
  },
  gettingStarted: {
    titleKey: "pokemonRandomizer_gettingStartedTitle",
    content: [
      `使用我们的工具开始您的第一次宝可梦随机生成器冒险非常简单！访问我们的生成器，选择您想要的随机化筛选条件——例如特定世代、属性或遭遇宝可梦的稀有度等级。如果您正在寻找快速的队伍构思，请决定您希望生成的宝可梦数量，或者为完整的随机游戏做好准备。我们直观的界面会引导您完成各种选项，让您轻松设置完美的随机化宝可梦体验。点击'生成'，让随机性尽情展现吧！`
    ],
  },
  faq: {
    titleKey: "pokemonRandomizer_faqTitle",
    content: [
      `**这个宝可梦随机生成器是免费的吗？** 当然！我们的工具对所有宝可梦粉丝完全免费。`, 
      `**我可以将此随机生成器用于特定的宝可梦游戏吗？** 虽然我们的工具会根据所有世代的数据生成随机宝可梦，但它主要用于创建随机列表或队伍。对于游戏内随机生成器，您通常需要能够修改游戏ROM的软件。我们的工具提供灵感和挑战思路。`, 
      `**宝可梦随机生成器的随机程度如何？** 我们利用强大的算法来确保在您设置的参数范围内具有高度的随机性，从而提供真正不可预测且公平的体验。`, 
      `**我可以保存我的宝可梦随机生成器设置吗？** 目前，设置仅适用于单次会话，但我们一直在根据用户反馈添加新功能！`
    ],
  },
};

export default pokemonRandomizerContent; 